export const FILTERS_ARGS = {
  SEARCH: 'search',
  PAID_AT: 'paid_at',
  PAID_AT_FROM: 'paid_at__gte',
  PAID_AT_TO: 'paid_at__lte',
  PAID_AT_DATE: 'paid_at__date',
  EXPIRES_IN: 'expires_in',
  EXPIRES_IN_FROM: 'expires_in__gte',
  EXPIRES_IN_TO: 'expires_in__lte',
  EXPIRES_IN_DATE: 'expires_in__date',
  DEACTIVATED_AT: 'deactivated_at',
  DEACTIVATED_AT_FROM: 'deactivated_at__gte',
  DEACTIVATED_AT_TO: 'deactivated_at__lte',
  DEACTIVATED_AT_DATE: 'deactivated_at__date',
  IS_ACTIVE: 'is_active',
};


export const SORT_ARGS = {
  ORDERING: 'ordering',
};
